import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    SummaryBlock,
    SummaryLeftSide as Left,
    SummaryImage as Image,
    SummaryText,
    SummaryRightSide as Right,
    FinishButton as Button,
    ButtonRow,
    WorkoutTitleInput,
    SummaryImageContainer,
} from './style';
import { Text } from '../../../UI/Text';
import { SummaryStats } from './SummaryStats';
import { getWorkoutType, selectInputContentOnFocus } from '../../../../Utils';
import { Input } from '../../../Components/Inputs/InputContainer';
import { Loading } from '../../WithLoading/Loading';
import { SpinnerBlack } from '../../../Components/Spiner/SpinnerBlack';
import { config } from '../../../../Configurations';

const TOGGLE_WORKOUT_TYPE_MODAL = 'workoutTypeModalState';
const TOGGLE_DESCRIPTION_MODAL = 'descriptionModalState';
const TOGGLE_SETTINGS_MODAL = 'settingsModalState';

class SummaryHeader extends Component {
    render() {
        const {
            props: {
                summary,
                workoutType,
                workoutTitle,
                workoutDescription,
                workoutImage,
                handleInputChange,
                toggleModal,
                submitWorkout,
                disableSubmitButton,
                workoutCreating,
                imageUploading,
            },
        } = this;

        return (
            <SummaryBlock>
                <Left>
                    <SummaryImageContainer src={workoutImage.imageBackground.overlay}>
                        <Loading isLoading={workoutImage.stockImageLoading}>
                            <Image src={`${config.baseUrl}/${workoutImage.stockImage}`} />
                        </Loading>
                    </SummaryImageContainer>

                    <SummaryText>
                        <Input>
                            <WorkoutTitleInput
                                onFocus={selectInputContentOnFocus}
                                value={workoutTitle}
                                onChange={handleInputChange}
                                name={'workoutTitle'}
                                autoComplete={'off'}
                            />
                        </Input>

                        <div
                            onClick={toggleModal.bind(this, TOGGLE_WORKOUT_TYPE_MODAL)}
                            style={{ display: 'flex', cursor: 'pointer' }}
                        >
                            <Text opacity={0.75} fontSize={12} weight={200} marginRight={'2px'}>
                                Workout type:
                            </Text>
                            <Text opacity={0.75} fontSize={12} weight={200}>
                                {getWorkoutType(workoutType)}
                            </Text>
                        </div>

                        <div onClick={toggleModal.bind(this, TOGGLE_DESCRIPTION_MODAL)} style={{ cursor: 'pointer' }}>
                            <Text opacity={0.75} fontSize={12} weight={200}>
                                {workoutDescription || 'Add description'}
                            </Text>
                        </div>
                    </SummaryText>
                </Left>
                <Right>
                    <ButtonRow>
                        <Button
                            disabled={disableSubmitButton || (workoutCreating || imageUploading)}
                            onClick={submitWorkout}
                        >
                            {workoutCreating || imageUploading ? <SpinnerBlack /> : 'Save'}
                        </Button>
                    </ButtonRow>
                    <SummaryStats toggleSettings={toggleModal.bind(this, TOGGLE_SETTINGS_MODAL)} {...summary} />
                </Right>
            </SummaryBlock>
        );
    }
}

const mapStateToProps = ({ workout: { statuses } }) => ({
    workoutCreating: statuses.isWorkoutCreating,
    imageUploading: statuses.isWorkoutImageUploading,
});

export default connect(mapStateToProps)(SummaryHeader);



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/RightBox/SummaryHeader.js